import { userBasePath } from 'src/utils/properties.utils';

export const fetchHighestRole = async (
  getEncryptedData: (key: string) => Promise<string | null>,
  storageKey: string
): Promise<string | null> => {
  try {
    return await getEncryptedData(storageKey);
  } catch (error) {
    console.error('Error fetching highest role:', error);
    return null;
  }
};

export const createLink = (path: string): string => {
  return `${userBasePath}/${path}`;
};
